const firebaseConfig = {
    apiKey: "AIzaSyB9oE0ArIKQ4f-YKlv6mH8Uvk4C_cAz-Pc",
    authDomain: "creative-agency-client-side.firebaseapp.com",
    databaseURL: "https://creative-agency-client-side.firebaseio.com",
    projectId: "creative-agency-client-side",
    storageBucket: "creative-agency-client-side.appspot.com",
    messagingSenderId: "728999542566",
    appId: "1:728999542566:web:01c7a25c24159e4579cbe7"
  }
  export default firebaseConfig;